<template>
  <QItem
    v-if="hasAccess"
    clickable
    :to="to"
  >
    <slot />
  </QItem>
</template>

<script>
import { dig } from "shared/helpers/object";

import { useUserStore } from "src/stores/user";

export default {
  name: "QItemRestricted",
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
  },
  setup() {
    const userStore = useUserStore();
    const { hasAccessLevel } = userStore;

    return { hasAccessLevel };
  },
  computed: {
    requiredAccessLevel() {
      const route = this.$router.resolve(this.to);
      const accessLevel = dig(route, "meta", "accessLevel");

      if (accessLevel) return accessLevel;

      const inheritedAccessLevel = [...route.matched]
        .reverse()
        .find(({ meta }) => meta && meta.accessLevel);

      return dig(inheritedAccessLevel, "meta", "accessLevel");
    },
    hasAccess() {
      return (
        !this.requiredAccessLevel ||
        this.hasAccessLevel(this.requiredAccessLevel)
      );
    },
  },
};
</script>
